import { createSlice } from '@reduxjs/toolkit';

// Service
import OAuthService from '../../services/OAuth.service';

const initialState = { value: null };

const publicKeySlice = createSlice({
  name: 'publicKey',
  initialState,
  reducers: {
    clean(state) {
      state.value = null;
    },
    set(state, action) {
      state.value = action.payload;
    },
  }
});

export const fetchPublicKey = () => {
  return async (dispatch) => {
    const response = await OAuthService.getPublicKey();
    dispatch(publicKeyAction.set(response.data));
  }
}

export const publicKeyAction = publicKeySlice.actions;

export default publicKeySlice;